import PropTypes from 'prop-types';
import { MultiSelect } from '@medifind/shared-basic-components';
import { areFilterStatesEqual } from '@medifind/zustand';
import { Filter } from './Filter';
import styles from './FilterShared.module.scss';

const StoreFilterFieldMulti = ({
  filter = {},
  onValueChange,
  onClear,
  classes,
  label,
  what,
  smallAt,
  isMenuListScroll,
  placeholder,
  data,
}) => {
  const { options, selected, getInitialState, setFilterValue, reset } = filter;

  return (
    <Filter
      classes={classes}
      label={label}
      what={what}
      smallAt={smallAt}
      onClear={() => {
        reset && reset();
        onClear && onClear();
      }}
      isChanged={!areFilterStatesEqual(getInitialState(), filter)}
    >
      <MultiSelect
        onChange={(...args) => {
          setFilterValue && setFilterValue(...args);
          onValueChange && onValueChange(...args);
        }}
        classes={{ ...classes, menuWrapper: styles['filter-menu-wrapper'], inputWrapper: styles['filter-input-wrapper'] }}
        labelId={'-'} // Is replaced by <Filter>
        items={data || options}
        selectedItems={selected}
        placeholder={placeholder}
        hideLabel
        isMenuListScroll={isMenuListScroll}
      />
    </Filter>
  );
};

StoreFilterFieldMulti.propTypes = {
  filter: PropTypes.any.isRequired,
  onValueChange: PropTypes.func,
  onClear: PropTypes.func,
  what: PropTypes.node,
  classes: PropTypes.object,
  label: PropTypes.string,
  smallAt: PropTypes.string,
  isMenuListScroll: PropTypes.bool,
  placeholder: PropTypes.string,
  data: PropTypes.array,
};

StoreFilterFieldMulti.defaultProps = {
  classes: {},
  label: '',
};

export { StoreFilterFieldMulti as default, StoreFilterFieldMulti };
